import { AuxCashTaxRateType } from 'pages/ValuationsAllocation/approaches/DiscountCashFlow/components/EffectiveTaxRateLedger/types';
import { ValuationWithReferences } from 'pages/ValuationsAllocation/types';
import BaseServiceRetryWrapper from './baseRetry';
import { VALUATIONS } from '../common/endpoints';

class ValuationService extends BaseServiceRetryWrapper {
  getValuation = (allocationId: string) => this.get(VALUATIONS.valuationByAllocationId(allocationId));

  createNewVersion = (valuation: ValuationWithReferences) =>
    this.put(VALUATIONS.createNewVersion(valuation.allocation_id?.toString() ?? ''), valuation);

  getValuationApproaches = (measurementDateId: string, allocationVersionId: string) =>
    this.get(VALUATIONS.getValuationApproaches(measurementDateId, allocationVersionId));

  updateValuation = (valuation: ValuationWithReferences) =>
    this.put(VALUATIONS.valuationByAllocationId(valuation.allocation_id?.toString() ?? ''), valuation);

  getGpc = (ticker: string, md: number, currency: string, calendarYears: string, customDate?: string) =>
    this.get(VALUATIONS.getGPC(ticker, md, currency, calendarYears, customDate));

  getPublicCompList = (
    tickerList: string[],
    md: string,
    currency: string,
    calendarYears: string,
    customDate: string,
    searchForIndexes = false
  ) => this.get(VALUATIONS.getPublicCompList(md, currency, tickerList.join(','), calendarYears, customDate, searchForIndexes));

  getEffectiveTaxRate = (companyMeasurementDate: string) =>
    this.get(VALUATIONS.getEffectiveTaxRate(companyMeasurementDate));

  saveEffectiveTaxRate = (data: AuxCashTaxRateType) => {
    if (data.id) {
      return this.put(VALUATIONS.updateEffectiveTaxRate(data.id?.toString() ?? ''), data);
    }
    return this.post(VALUATIONS.createEffectiveTaxRate, data);
  };

  getFirmCompGroups = (firmId: number) => this.get(VALUATIONS.getFirmCompGroups(`${firmId}`));

  getTickerByKeyword = (keyword: string) => this.get(VALUATIONS.getTickerByKeyword(keyword));

  getTransaction = (transactionId: string) => this.get(VALUATIONS.getTransaction(transactionId));

  setReadyForAudit = (valuationId: string, data: unknown) => this.put(VALUATIONS.setReadyForAudit(valuationId), data);
}

export default ValuationService;
